var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2929 1.29289C11.6834 0.90237 12.3166 0.90237 12.7071 1.29289L17.7071 6.29289C18.0976 6.68342 18.0976 7.31658 17.7071 7.70711C17.3166 8.09763 16.6834 8.09763 16.2929 7.70711L13 4.41421V18C13 18.5522 12.5523 19 12 19C11.4477 19 11 18.5522 11 18V4.41421L7.70711 7.70711C7.31658 8.09763 6.68342 8.09763 6.29289 7.70711C5.90237 7.31658 5.90237 6.68342 6.29289 6.29289L11.2929 1.29289ZM3 13C3 12.4477 2.55228 12 2 12C1.44772 12 1 12.4477 1 13V20C1 21.6569 2.34315 23 4 23H20C21.6569 23 23 21.6569 23 20V13C23 12.4477 22.5523 12 22 12C21.4477 12 21 12.4477 21 13V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V13Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.ac45924e88b1f72efb2e25f41ece0327.svg";
export { ForwardRef as ReactComponent };